module.exports = __webpack_public_path__ + "img/item-1.9c9d230.svg";